export default __webpack_public_path__ + "static/嘉宾头像_邢磊-3dc76a8823eb03dfeb4e4b24687f29a3.png";